function header () {
    // Настройка заливки для шапки
    document.addEventListener('scroll', function() {
        window.scrollY >= 1 ? document.body.classList.add('header-painted') : document.body.classList.remove('header-painted');
    });

    // При клике на бургер
    const burger = document.querySelector('.header__burger')
    const nav = document.querySelector('.nav')

    burger.addEventListener('click', ()=> {
        burger.classList.add('active')
        nav.classList.add('show')
    });
}

export default header;